import { dropLast } from 'ramda';

import { COOKIE_NAME, COOKIE_PARTS_KEYS } from 'js/utils/affiliate.util';
import { getCookie, setCookie } from 'js/utils/cookie.util';

export const getAffiliateData = (cookieName = COOKIE_NAME) => {
    const cookie = getCookie(cookieName);

    if (!cookie) {
        return {};
    }

    const cookieObj = {};
    const cookieParts = cookie.split(',');

    if (cookieParts.length === 1) {
        cookieObj.advertiser = cookieParts[0];
    } else if (cookieParts.length === COOKIE_PARTS_KEYS.length) {
        for (const cookiePartKey of COOKIE_PARTS_KEYS) {
            cookieObj[cookiePartKey] = cookieParts.shift();
        }
    }

    return cookieObj;
};

export const getFormattedCookie = (cookie) => cookie.length > 1
    ? dropLast(1, cookie).join('')
    : cookie.join('');

export const setBannerCookie = (params = {}, cookieName = COOKIE_NAME) => {
    const cookie = [];
    let isNotEmptyParameters;

    if (Object.keys(params).length === 1 && Boolean(params.advertiser)) {
        cookie.push(params.advertiser.replace(/;/g, encodeURIComponent(';')));
        isNotEmptyParameters = true;
    } else {
        Object.keys(COOKIE_PARTS_KEYS).forEach((paramName) => {
            if (params[paramName]) {
                cookie.push(params[paramName].replace(/;/g, encodeURIComponent(';')));
                isNotEmptyParameters = true;
            }

            cookie.push(',');
        });
    }

    if (isNotEmptyParameters) {
        setCookie(cookieName, getFormattedCookie(cookie), { expires: 1, path: '/' });
    }
};
